<!-- Render only when visible to avoid mounting an empty dialog in the DOM -->
@if (visible()) {
<app-dialog [title]="dialogTitle()" [visible]="visible()" class="h-[80dvh] max-w-[50dvw]" (closed)="close()">

  <ng-template #bodyTemplate>
    <!-- min-h-full lets the column fill the body scroll area;
         flex-col + flex-1 on the textarea section make it stretch to fill what's left -->
    <div class="flex flex-col gap-3 py-1 min-h-full">

      <!-- ── Prompt name ── -->
      <div class="flex flex-col gap-0 flex-shrink-0">
        <label class="text-sm font-semibold text-[#5f5f5f] tracking-[-0.21px]">
          Prompt name <span class="text-danger">*</span>
        </label>
        <app-input type="text" placeholder="Type here" [ngModel]="formTitle()"
          (ngModelChange)="formTitle.set($event)" />
      </div>

      <!-- ── Group + Share with dropdowns (side by side) ── -->
      <div class="flex gap-3 items-start flex-shrink-0">

        <!-- Group multi-select — only shown when options are provided -->
        @if (groupOptions().length > 0) {
        <div class="flex flex-col gap-0 flex-1 min-w-0">
          <label class="text-sm font-semibold text-[#5f5f5f] tracking-[-0.21px]">
            Group
          </label>
          <!-- Two-way [(value)] binding keeps formGroupIds in sync with the selection -->
          <app-multi-select [(value)]="formGroupIds" [options]="groupOptions()"
            [config]="{ placeholder: 'Select groups…', appendTo: 'body', display: 'chip', showToggleAll: false }" />
        </div>
        }

        <!-- Share with dropdown — Personal (default) / Team -->
        <div class="flex flex-col gap-0 flex-1 min-w-0">
          <label class="text-sm font-semibold text-[#5f5f5f] tracking-[-0.21px]">
            Share with <span class="text-danger">*</span>
          </label>
          <app-select [options]="accessLevelOptions" [value]="formAccessLevel()"
            (onChange)="formAccessLevel.set($event.value)" [config]="{ placeholder: 'Select share with', showClear: false }" />
        </div>

      </div>

      <!-- ── Prompt content — flex-1 + min-h-0 fill all remaining vertical space ── -->
      <div class="flex flex-col gap-0 flex-1 min-h-0">
        <label class="text-sm font-semibold text-[#5f5f5f] tracking-[-0.21px] flex-shrink-0">
          Prompt <span class="text-danger">*</span>
        </label>
        <!-- class="h-full resize-none" is forwarded to the underlying <textarea> element -->
        <app-input type="textarea" class="h-full min-h-[45dvh]" placeholder="Type here" [ngModel]="formContent()"
          (ngModelChange)="formContent.set($event)" />
      </div>

    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <div class="flex justify-end gap-2 pt-1">
      <app-button label="Cancel" variant="outlined" (clicked)="close()" />
      <app-button [label]="saveLabel()" variant="filled" severity="primary" [disabled]="!isValid()"
        [loading]="loading()" (clicked)="save()" />
    </div>
  </ng-template>

</app-dialog>
}
